import { render, staticRenderFns } from "./VeJwTjChengjiList.vue?vue&type=template&id=f794020a&scoped=true"
import script from "./VeJwTjChengjiList.vue?vue&type=script&lang=js"
export * from "./VeJwTjChengjiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f794020a",
  null
  
)

export default component.exports